import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';
import { Email } from '../models/email.model';

@Injectable()
export class EmailService {
    private readonly additionalHeaders =  new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: HttpClient) { }

    sendEmail(email: Email): Observable<boolean> {
        return this.http.post<boolean>(`${environment.apiUrl}/sendemail`, email, {headers: this.additionalHeaders});
    }
}



// WEBPACK FOOTER //
// ./src/app/services/email.service.ts